import React from 'react';
import { useCustomComponent } from '@/hooks';
import { Text } from '@/components/ui/Text';

export interface DateUnsureCheckboxProps {
  checked: boolean;
  text: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const DateUnsureCheckboxComponent: React.FC<DateUnsureCheckboxProps> = ({
  checked,
  text,
  disabled = false,
  onChange,
}) => {
  return (
    <div className="peptalk-date-unsure-checkbox">
      <label className="peptalk-checkbox-label">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="peptalk-checkbox"
        />
        <Text size="sm" color="secondary">
          {text}
        </Text>
      </label>
    </div>
  );
};
export const DateUnsureCheckbox: React.FC<DateUnsureCheckboxProps> = (
  props: DateUnsureCheckboxProps
) => {
  const Component = useCustomComponent({
    componentName: 'DateUnsureCheckbox',
    Component: DateUnsureCheckboxComponent,
  });

  return <Component {...props} />;
};
